import { iFile, iFileVersions, SingleType } from "./File"

export interface iVideoFile extends iFile {
  versions?: iVideoVersions
}

export interface iVideoVersions extends iFileVersions {
  v360p?: SingleType
  v480p?: SingleType
  v720p?: SingleType
}

export enum eVideoVersions {
  original = "original",
  v360p = "v360p",
  v480p = "v480p",
  v720p = "v720p",
}
